import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { QueryExtraAchievementsDTO } from "../dtos/index.v2";
import {
  deleteExtraAchievments,
  getExtraAchievments,
} from "@/modules/agents/api/index.v2";

export const useExtraAchievments = ({
  query,
  enabled = true,
}: {
  query: QueryExtraAchievementsDTO;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: ["extraAchievments", query],
    queryFn: async ({ signal }) => await getExtraAchievments({ query, signal }),
    enabled,
  });
};

export const useDeleteExtraAchievement = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteExtraAchievments,
    onSuccess: () => {
      queryClient.invalidateQueries(["extraAchievments"]);
      queryClient.invalidateQueries(["agentsTargets"]);
    },
  });
};
